import { render, staticRenderFns } from "./IdoneitaSpirografiaViewComponent.vue?vue&type=template&id=6106d920"
import script from "./IdoneitaSpirografiaViewComponent.vue?vue&type=script&lang=js"
export * from "./IdoneitaSpirografiaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports